export enum ObligationStatus {
    HAVE_LOAN = 'have_loan',
    DEBT_FREE = 'debt_free'
}
